import { faAddressBook } from '@fortawesome/pro-solid-svg-icons/faAddressBook';
import { faBriefcase } from '@fortawesome/pro-solid-svg-icons/faBriefcase';
import { faTag } from '@fortawesome/pro-solid-svg-icons/faTag';
import { faUser } from '@fortawesome/pro-solid-svg-icons/faUser';
import { ColourStateSolid } from '@ukpostbox/frontend-framework';
import AddressBook from '../Pages/Account/AddressBook';
import BusinessDetails from '../Pages/Account/BusinessDetails';
import PersonalDetails from '../Pages/Account/PersonalDetails';
import Tags from '../Pages/Account/Tags';
import { SuggestibleRouteInterface } from '../../_Global/Types/RouteTypes';

const AccountRoutes: Array<SuggestibleRouteInterface> = [
	{
		title: 'Personal Details',
		path: '/manage-account/personal-details',
		icon: faUser,
		element: <PersonalDetails />,
		colour: ColourStateSolid.Primary,
		group: 'Your User',
	},
	{
		title: 'Business Details',
		path: '/manage-account/business-details',
		icon: faBriefcase,
		element: <BusinessDetails />,
		colour: ColourStateSolid.Primary,
		group: 'Your User',
	},
	{
		title: 'Address Book',
		path: '/manage-account/address-book',
		icon: faAddressBook,
		element: <AddressBook />,
		colour: ColourStateSolid.Primary,
		group: 'Your User',
	},
	{
		title: 'Tags',
		path: '/manage-account/tags',
		icon: faTag,
		element: <Tags />,
		colour: ColourStateSolid.Primary,
		group: 'Your User',
	},
];

export { AccountRoutes };
